// src/components/AIAssistantAvatar.jsx
// Shared gradient avatar used by the chat header logo (md) and beside each
// assistant message bubble (sm). Centralized so the visual signature stays
// consistent across the chat surface.

import React from 'react';

const SIZES = {
  sm: 'w-6 h-6 text-[11px]',
  md: 'w-8 h-8 text-sm',
  lg: 'w-12 h-12 text-xl',
};

export default function AIAssistantAvatar({ size = 'md', className = '' }) {
  return (
    <div
      className={`${SIZES[size]} flex-shrink-0 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600
        ring-1 ring-white/20 dark:ring-white/10
        flex items-center justify-center text-white
        shadow-sm shadow-indigo-500/30 ${className}`}
      aria-hidden="true"
    >
      ✨
    </div>
  );
}
